module.exports = new __parcel__URL__("team-picker-empty-state.357906ab.svg").toString();